import {
  ON_SET_CUSTOM_EVENTS,
  ON_SHOW_ALL_EVENTS_CLICKED,
  ON_SELECTED_CURRENCY_CHANGE
} from '../actions';

const initialState = {
  slugs: [],
  events: {}
};

export default (state = initialState, action) => {
  if (action.type === ON_SET_CUSTOM_EVENTS) {
    return {
      slugs: action.payload.slugs,
      events: action.payload.events
    };
  }
  else if (action.type === ON_SHOW_ALL_EVENTS_CLICKED || action.type === ON_SELECTED_CURRENCY_CHANGE) {
    return initialState;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/selected-events.js